import { useSelector } from "../../redux-store";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { DoraButton } from "dora-shared/frontend";
import { selectFormData } from "../../ducks/app/teams-dialog/selectors";
import { useDialogActions } from "../../ducks/app/teams-dialog/hooks";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { UFMuiTextField } from "../UFMuiTextField";

type DialogContentData = { teamId?: string; name: string; description: string };

const TeamDialogContent = ({
  initialData,
}: {
  initialData: DialogContentData;
}) => {
  const { t } = useTranslation(["settings", "components"]);
  const dialogActions = useDialogActions();
  const isEdit = !!initialData.teamId;
  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    defaultValues: {
      name: initialData.name,
      description: initialData.description,
    },
  });
  const onSubmit = handleSubmit(async (formValues) => {
    dialogActions.submit({
      ...formValues,
      ...(initialData.teamId && { teamId: initialData.teamId }),
    });
  });
  return (
    <Dialog open={true} onClose={dialogActions.close}>
      <form onSubmit={onSubmit}>
        <DialogTitle>
          {isEdit
            ? t("teamDialog.editDialogTitle")
            : t("teamDialog.addNewDialogTitle")}
        </DialogTitle>
        <DialogContent>
          <UFMuiTextField
            control={control}
            required
            label={t("team.name")}
            name="name"
            autoFocus
          />
          <UFMuiTextField
            control={control}
            label={t("team.description")}
            name="description"
          />
        </DialogContent>
        <DialogActions sx={{ padding: "16px 24px" }}>
          <DoraButton variant="primary" type="button" onClick={dialogActions.close}>
            {t("components:buttonLabels.cancel")}
          </DoraButton>
          <DoraButton variant="primary-filled" disabled={isSubmitting} type="submit">
            {t("team.saveButton")}
          </DoraButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const TeamDialog = () => {
  const data = useSelector(selectFormData);
  return data && <TeamDialogContent initialData={data} />;
};

export default TeamDialog;
